export const is5xxStatus = (status: string) => /^5\d{2}$/.test(status);

export const is422Status = (status: string) => status === '422';

export const is4xxStatus = (status: string) => /^4\d{2}$/.test(status);
